export const EntityType = {
  BOOKMARK_ALL: "bookmark_all",
  BOOKMARK_FOLDER_ALL: "bookmark_folder_all",
};

export const QueryKeys = {
  bookmarkAll: () => [EntityType.BOOKMARK_ALL, "LIST"],
  bookmarkFolderAll: () => [EntityType.BOOKMARK_FOLDER_ALL, "LIST"],
};
